import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    width: 100%;
    margin-top: 32px;
`;

export const AllTransactionText = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #000000;
`;

export const TabWrapper = styled.div`
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
`;

export const ItemCardWrapper = styled.div`
    margin: 6px 0;
`;

export const Hr = styled.div`
    display: flex;
    width: 100%;
    height: 0;
    border: 1px solid #e7e7f0;
`;

export const NoResult = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-top: 20px;
`;

export const ModalLoaderWrapper = styled.div`
    display: flex;
    height: 200px;
    justify-content: center;
    align-items: center;
`;
